export const DEFAULT_APP_TIMEZONE = "America/Los_Angeles";

export function dateInTimeZone(date = new Date(), timeZone = DEFAULT_APP_TIMEZONE) {
  const fields = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(date);
  const value = (type: Intl.DateTimeFormatPartTypes) => fields.find((part) => part.type === type)?.value;
  return `${value("year")}-${value("month")}-${value("day")}`;
}

export function daysAgoInTimeZone(days: number, timeZone = DEFAULT_APP_TIMEZONE) {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() - days);
  return dateInTimeZone(date, timeZone);
}
